<template>
  <div class="image-slider" uk-slider :style="`width:${width};`">
    <div class="uk-position-relative" tabindex="-1">

      <div class="uk-slider-container">
        <div class="uk-slider-items">
          <component v-for="(image, i) in images" :key="i" class="uk-width-1-1 slider-item" :is="image.link ? 'a' : 'div'" :href="image.link ?? ''">
            <img
              :src="image.url"
              :alt="image.alt"
              :style="`object-fit:${objectFit};width:${width};height:${height}`"
            />
            <div class="image-label uk-overlay uk-overlay-primary uk-position-bottom uk-text-center" v-if="image.bottomText">
              <p class="uk-margin-remove">{{ image.bottomText }}</p>
            </div>
          </component>
        </div>
      </div>
      <a
      class="slide-side-nav uk-position-center-left-out"
      href
      uk-slidenav-previous
      uk-slider-item="previous"
    ></a>
    <a
      class="slide-side-nav uk-position-center-right-out"
      href
      uk-slidenav-next
      uk-slider-item="next"
    ></a>
    </div>

    <ul class="uk-slider-nav uk-thumbnav">
      <li v-for="(image, i) in images" :uk-slider-item="i" @click="onSelectThumbnav(i)">
        <img :src="image.url">
      </li>

    </ul>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import UIkit from 'uikit'

/**
 * 日軽専用のスライダーコンポーネント
 *
 * V2からの移行にあたらり、調整が必要だったが元のコンポーネントのDOM構造から変更が必要だったため切り出し
 * 他環境でも使う要望があれば共通コンポーネントとして切り出しを検討する
 *
 * ・< >ナビの外だし
 * ・サムネイル表示
 */

defineProps({
  /**
   * 画像データオブジェクトの配列
   *
   * 画像データオブジェクト
   * {
   *   url: https://gazou_url/xxx.png, 画像URL（必須）
   *   alt: "画像の説明", 画像のalt（任意）
   *   bottomText: "画像タイトル" 画像の下部に表示させるテキスト文字列 (任意)
   * }
   */
  images: {
    type: Array,
    default: [],
    required: true,
  },

  /**
   * スライドショーの幅
   * ex) 400px
   * デフォルト値（100%）のままにして、親要素でサイズ決める形の方がよさそう？
   */
  width: {
    type: String,
    default: "100%",
  },
  /**
   * スライドショーの高さ
   * ex) 300px
   */
  height: {
    type: String,
    default: "100%",
  },
  /**
   * object-fit（cssプロパティ）
   */
  objectFit: {
    type: String,
    default: "cover",
  },
  /**
   * 自動スライド
   */
  autoplay: {
    type: Boolean,
    default: false,
  },
});

let slider = null

onMounted(() => {
  slider = UIkit.slider(".image-slider")
})



function onSelectThumbnav(i) {
  slider.show(i)

}


</script>

<style lang="scss" scoped>


.slide-side-nav {
  cursor: pointer;
  transition: all .25s;
  transform: scale(1);
  transform-origin: center;

  * {
    cursor: pointer;
    pointer-events: none;
  }

  &:hover {
    transform: scale(1.25);
    transform-origin: center;
        opacity: 0.5;
  }
}

.uk-thumbnav {
  margin-top: 1rem;
  justify-content: center;
  margin-left: 0;
  gap: .5rem;

  > * {
      padding-left: 0
  }

  li {
    width: 86px;
    height:  60px;
    position: relative;
    overflow: hidden;

    &.uk-active {
      &::before {
        content: "";
        border-top: solid 3px var(--theme-color);
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: #fffa;
      }
    }

    img {
      object-fit: cover
    }
   }
}

.image-label.uk-overlay  {
  font-size: .875rem;
  padding: .5rem;
  color: #eee;
}
</style>